
<template>
  <div class="ranking">
    <div class="ranking_mask"></div>
    <div class="bg cssFn_show">
      <div class="ranking_close" @click="ranking_close"></div>
      <!-- 左侧选项卡 S -->
      <div class="menu">
        <span :class="{cur:index===0}" @click="titleChangge(0)">{{ranking_menu_text[0]}}</span>
        <span :class="{cur:index===1}" @click="titleChangge(1)">{{ranking_menu_text[1]}}</span>
      </div>

      <div class="title">{{title}}</div>
      <!-- 排行榜标题s -->
      <!-- 答题排行 S -->
      <div class="ranking_list" v-show="index===0">
        <ul v-show="rankdata_student_list.length>0">
          <li v-for="(itme,index) in rankdata_student_list" :key="index">
            <span class="ranking_num">
              <img
                v-show="itme.r < 4"
                :src="'/static/img/video/ranking_num'+itme.r+'.png'"
                alt
              >
              <em v-show="itme.r > 3">{{itme.r}}</em>
            </span>
            <span class="ranking_user_img">
              <img :src="baseUrl + itme.a" alt>
            </span>
            <span class="ranking_user_name">{{itme.n}}</span>
            <span class="ranking_qnum">
              <em>{{itme.e || 0}}</em>道
            </span>
          </li>
        </ul>
        <div class="none_class1" v-show="!rankdata_student_list.length">
          <img src="../../../assets/img/video/none_class.png" alt>
          <div>亲爱的宝贝：你还没有小班，暂无答题排行哦!</div>
        </div>
      </div>
      <!-- 答题排行 E -->

      <!-- 小班排行 S -->
      <div class="ranking_list" v-show="index===1">
        <ul>
          <li v-for="(itme,index) in rankdata_small_class_list" :key="index">
            <span class="ranking_num">
              <img v-if="itme.r<4" :src="'/static/img/video/ranking_num'+itme.r+'.png'" alt>
              <em v-else>{{itme.r}}</em>
            </span>
            <span class="ranking_user_name ranking_user_name1">{{itme.n|formatText}}</span>
            <span class="ranking_qnum">
              <em>{{itme.a || 0}}</em>道
            </span>
          </li>
        </ul>
      </div>
      <!-- 小班排行 E -->

      <!-- 排行榜底部 s -->
      <div class="ranking_bot">
        <div class="q_rank" v-show="index==0">
          <span v-show="my_class.n">
            班内排名：
            <em>{{my.r>0?my.r:"--"}}</em>
          </span>
          <span>
            <img :src="+my.a?baseUrl+my.a:user_photo" alt>
            {{my.n}}
          </span>
          <span>
            答对
            <em>{{my.e}}</em>
          </span>
          <span>
            答题
            <em>{{my.g}}</em>
          </span>
        </div>
        <div class="c_rank" v-show="index==1 && my_class.n">
          <span>所在小班：{{my_class.n|formatText}}</span>
          <span v-if="my_class.r>0">
            排名：
            <em>{{my_class.r}}</em>
          </span>
          <span v-else>无人答题</span>
        </div>
        <div class="none_class" v-show="index==1 && !my_class.n">亲爱的宝贝：你还没有小班，暂无答题排行喔!</div>
      </div>
      <!-- 排行榜底部 E -->
    </div>
  </div>
</template>

<script>
import { mapState  } from "vuex";
export default {
  name: "ranking",
  data() {
    return {
      title: "", //是否有班级小班平均答对题目排行榜
      index: 0, //选项卡切换值
      ranking_menu_text: ["答题排行", "小班排行"], //选项卡切换文字
      my: {},
      my_class: {},
      rankdata_student_list: [],
      rankdata_small_class_list: [],
      baseUrl:'',
    };
  },
  props: {
    rankingData: {
      type: Object,
      default: {}
    },
  },
  filters: {
    formatText(v) {
      return v ? v.substring(0, 10) : v;
    }
  },
  created() {
    this.rankInit();
  },
  computed: {
    ...mapState(["lesson_id","user_photo"])
  },
  mounted() {},
  methods: {
    rankInit(){
      this.my = this.rankingData.my;
      this.my_class = this.rankingData.myClass;
      this.rankdata_student_list = this.rankingData.studentList;
      this.rankdata_small_class_list = this.rankingData.smallClassList;
      this.baseUrl = this.rankingData.url
      this.titleChangge(0);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLiveRank",
        data: {
          unique_id: this.rankingData.unique_id,
          type: 1
        }
      });
    },
    titleChangge(index) {
      if (index == 0 && this.my_class.n) {
        this.title = `${this.my_class.n.substring(0, 10)}答对题目排行榜`;
      }
      if (index == 0 && !this.my_class.n) {
        this.title = "答题榜";
      }
      if (index == 1) {
        this.title = "小班平均答对题目排行榜";
      }
      this.index = index;
    },
    ranking_close() {
      this.$emit("ranking_close");
    },
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.ranking {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 81;
  .ranking_mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 78;
  }
  .cssFn_show {
    animation: bounceIn 0.5s 0.2s ease both;
    -webkit-animation: bounceIn 0.5s 0.2s ease both;
  }
  .cssFn_hide {
    animation: bounceOut 0.5s 0.2s ease both;
    -webkit-animation: bounceOut 0.5s 0.2s ease both;
  }

  .bg {
    background: url("../../../assets/img/video/rankingBG.png") no-repeat;
    background-size: 100%;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 79;
    width: 690px;
    height: 469px;
    margin-top: -235px;
    margin-left: -336px;
    border-radius: 0px 0px 20px 20px;
    .none_class1 {
      text-align: center;
      color: #b8c3cb;
      font-size: 20px;
      img {
        width: 285px;
        height: auto;
        margin-top: 25px;
      }
    }
    .ranking_close {
      background: url("../../../assets/img/video/ranking_close.png") no-repeat;
      position: absolute;
      top: -15px;
      right: -47px;
      width: 42px;
      height: 42px;
      z-index: 90;
      background-size: 100%;
      cursor: pointer;
    }
    .title {
      font-size: 24px;
      margin-top: 30px;
      color: #fff;
    }
    .ranking_list {
      margin: 0 50px;
      text-align: left;
      margin-top: 64px;
      height: 250px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 6px;
        box-shadow: inset 0 0 5px #d7d7d7;
        background: #d7d7d7;
        //   -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: #fff;
        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      }
      li {
        margin-bottom: 30px;
        height: 34px;
      }
      span {
        display: inline-block;
      }
      .ranking_num {
        width: 32px;
        height: 28px;
        font-size: 0px;
      }
      .ranking_num em {
        width: 32px;
        height: 28px;
        display: block;
        text-align: center;
        color: #003057;
        font-size: 21px;
        position: relative;
        top: 5px;
      }
      .ranking_num img {
        width: 32px;
        height: 28px;
        text-align: center;
        position: relative;
        top: -5px;
      }
      .ranking_user_img {
        box-sizing: border-box;
        margin: 0 26px;
        border: 2px solid #245d72;
        border-radius: 50%;
        overflow: hidden;
        width: 38px;
        vertical-align: middle;
        height: 38px;
      }

      .ranking_user_img img {
        width: 34px;
        height: 34px;
      }
      .ranking_user_name {
        color: #004466;
        font-size: 21px;
        position: relative;
        top: 5px;
      }
      .ranking_user_name1 {
        margin-left: 15px;
        width: 210px;

        color: #003057;
        font-size: 21px;
        position: relative;
        top: 5px;
      }
      .ranking_qnum {
        float: right;
        font-size: 21px;
        margin-right: 15px;
        color: #004466;
        em {
          color: #EA583C;
        }
      }
    }
    .ranking_bot {
      height: 57px;
      border-top: 1px #9ebfc8 solid;
      padding: 0 50px;
      margin-top: 15px;
      text-align: left;
      font-size: 21px;
      padding-top: 20px;
      color: #004466;
      em {
        color: #EA583C;
      }
      img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        position: relative;
        top: -3px;
        margin-right: 12px;
        border: 2px solid #245d72;
      }
      .q_rank span:first-child {
        margin-right: 43px;
      }
      .c_rank span:first-child {
        margin-right: 30px;
      }
      .q_rank span:nth-last-child(2) {
        margin-left: 30px;
      }
      .q_rank span:last-child {
        margin-left: 15px;
      }
    }
    .menu {
      font-size: 21px;
      position: absolute;
      top: 90px;
      left: -60px;
      height: 290px;
      span {
        width: 60px;
        height: calc(50% - 8px);
        writing-mode: vertical-rl;
        line-height: 60px;
        text-align: center;
        display: block;
        background: #fff;
        border-radius: 20px 0px 0px 20px;
        margin-top: 8px;
        color: silver;
        cursor: pointer;
      }
      .cur {
        color: #F57F22;
      }
    }
    .none_class {
      color: #b8c3cb;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/video/ranking.vue